import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { successToast, errorToast } from "../../../components/toastmessage/toastmessage";
import { postWardApiCall } from "./watchService";


const useAddWardHook = (initialState) => {
    const navigate = useNavigate();
    const [wardState, setWardState] = useState(initialState);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setWardState((prevFormState) => ({
            ...prevFormState,
            [name]: value,
        }));

    }

    const handleWardSubmit = async (event) => {
        event.preventDefault();
        try {
            let payload = {
                ...wardState,
                createdBy: JSON.parse(sessionStorage.getItem("tenantDetails"))[0]?.createdBy,
                tenantID: JSON.parse(sessionStorage.getItem("tenantDetails"))[0]?.tenantID,
                activeStatus: wardState?.activeStatus === "true" ? true : false
            }
            let result = await postWardApiCall(payload);
            if (result?.status === 200) {
                successToast("Successfully Inserted");
                setWardState(initialState)
            }
        } catch (e) {
            errorToast("Something went wrong")
        }


    }
    const handleGoBack = () => {
        navigate("/master/ward-list")
    }
    return {
        wardState,
        setWardState,
        handleInputChange,
        handleWardSubmit,
        handleGoBack
    }


};


export default useAddWardHook;
